"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var quill_1 = __importStar(require("quill"));
var Scope = quill_1.default.import('parchment').Scope;
/**
 * Class to provide keyboard bindings that override the quill default bindings
 */
var QuillKeyboardBindings = /** @class */ (function () {
    function QuillKeyboardBindings() {
    }
    /**
     * Binding to handle Enter events within the quill editor.
     *
     * This is needed because Quill (as of 2.0.3) by default does not preserve
     * styles when creating a newline, which is not desirable.
     *
     * Before V2, Quill would preserve styles, but the logic was removed here:
     * https://github.com/slab/quill/pull/3428
     *
     * The custom handler here restores logic that was removed in the above pull request.
     */
    QuillKeyboardBindings.prototype.handleEnter = function (quill, range, context) {
        // This logic matches the existing behavior in Quill
        var lineFormats = Object.keys(context.format).reduce(function (formats, format) {
            if (quill.scroll.query(format, Scope.BLOCK) &&
                !Array.isArray(context.format[format])) {
                formats[format] = context.format[format];
            }
            return formats;
        }, {});
        var delta = new quill_1.Delta()
            .retain(range.index)
            .delete(range.length)
            .insert('\n', lineFormats);
        quill.updateContents(delta, quill_1.default.sources.USER);
        quill.setSelection(range.index + 1, quill_1.default.sources.SILENT);
        // This logic restores the logic that was removed here to preserve styles.
        // https://github.com/slab/quill/pull/3428
        // It's just copied straight from the quill source code.
        Object.keys(context.format).forEach(function (name) {
            if (lineFormats[name] != null) {
                return;
            }
            if (Array.isArray(context.format[name])) {
                return;
            }
            if (name === 'code' || name === 'link') {
                return;
            }
            quill.format(name, context.format[name], quill_1.default.sources.USER);
        });
    };
    return QuillKeyboardBindings;
}());
exports.default = QuillKeyboardBindings;
(function (angularModule) {
    angularModule.service('pr.quillKeyboardBindings', QuillKeyboardBindings);
})(angular_1.module('qualtrics.pr'));
